import { queryKeys } from '../queryKeys';

import type { ContinueWatchingSettings } from './getContinueWatchingSettings';
import { fetchWatchedAssets } from './queryFunctions';

export type CreateContinueWatchingQueryOptionsArgs = {
  referenceId: string;
  pageSize: number;
  settings: ContinueWatchingSettings;
};

export function createContinueWatchingQueryOptions({
  pageSize,
  referenceId,
  settings,
}: CreateContinueWatchingQueryOptionsArgs) {
  return {
    queryKey: queryKeys.continueWatching(referenceId, pageSize),
    queryFn: ({ pageParam }: { pageParam: number }) =>
      fetchWatchedAssets({
        ...settings,
        pageIndex: pageParam,
        pageSize,
      }),
  };
}
